import Immutable from 'immutable';
import moment from 'moment';
import { OFFSET } from '../../utils/constants';

const LOAD = 'mvSalesComparisons/LOAD';
const LOAD_SUCCESS = 'mvSalesComparisons/LOAD_SUCCESS';
const LOAD_FAIL = 'mvSalesComparisons/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'mvSalesComparisons/LOAD_ADD_SUCCESS';
const LOAD_GET_VALUE_BY_ID = 'mvSalesComparisons/LOAD_GET_VALUE_BY_ID';

const initialState = Immutable.fromJS({
  MvSalesComparisons: null,
  loading: false,
  errorMessage: null,
  activePage: 1,
  data: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('MvSalesComparisons', action.MvSalesComparisons);


    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('MvSalesComparison', action.result);

    case LOAD_GET_VALUE_BY_ID: 
    return state
    .set('loading', false)
    .set('data', action.data);

    default:
    return state;
  }
}

export const getMarketValueSalesComparsisons = (offset, page) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get(`/marketValueSalesComparsisons/${offset}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    if (res && res.rows) {
      res.rows = res.rows.map(r => Object.assign({}, r, {
        date_Sold: r.date_Sold ? moment.utc(r.date_Sold).format('MM/DD/YYYY') : ''
      }));
    }
    dispatch({ type: LOAD_SUCCESS, MvSalesComparisons: res, page });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};


export const addMarketValueSalesComparsisons = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  let page = 1;
  let offset = 0
  try {

    const res = await api.post('/marketValueSalesComparsisons', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getMarketValueSalesComparsisons(offset, page));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res, page });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const saveSaleComparisons = (payload) =>  async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try { 
    let res;
    const data = { comparisonData: payload }
    if(payload.id) {      
      res = await api.put('/marketValueSalesComparsisons', { data });
    } else {
      res = await api.post('/marketValueSalesComparsisons', { data });
    }
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
}


export const updateMarketValueSalesComparsisons = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/marketValueSalesComparsisons', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const deleteMarketValueSalesComparsisons = (id) => async (dispatch, getState, api) => { 
  dispatch({ type: LOAD });
  try {
    const data = { id: id };
    const res = await api.del('/marketValueSalesComparsisons', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const getMarketValueSalesComparsisonsById = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/marketValueSalesComparsisons/marketValueSalesComparsisonsGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res.data;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/mvSalesComparisons.js